import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 25301 28763"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#fefefe;stroke-width:280.382}.fil0{fill:#231f20}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M12936 12020c-1304-158-2489 772-2647 2076-157 1304 772 2489 2076 2647 1305 158 2489-772 2647-2076s-771-2489-2076-2647z"
                className="fill stroke1"
        style={{
          strokeWidth: 280.382,
        }}

      />
      <path
        d="m10794 11023-73 1307c587-552 1405-850 2268-746 622 75 1169 350 1592 749l-73-1313c-420-232-890-391-1396-452-834-101-1636 77-2318 455z"
                className="fill stroke1"
        style={{
          strokeWidth: 280.382,
        }}

      />
      <path
        d="M13163 10148c470 57 912 192 1318 384l-512-9146c-40-699-618-1246-1318-1246-701 0-1279 547-1318 1246l-512 9148c705-336 1509-487 2342-386zM8814 14310l1095 717c-185-785-33-1642 488-2337 376-501 888-838 1445-1004l-1174-593c-411 247-784 574-1089 982-505 672-752 1455-765 2235z"
                className="fill stroke1"
        style={{
          strokeWidth: 280.382,
        }}

      />
      <path
        d="M9240 11821c285-379 622-694 992-949L2055 6742c-625-315-1388-88-1738 519-350 606-165 1380 420 1764l7667 5017c61-779 333-1550 836-2221zM10670 17669l1169-590c-772-233-1439-793-1780-1592-246-576-282-1187-147-1753l-1101 720c9 480 106 966 306 1435 330 772 884 1378 1553 1780z"
                className="fill stroke1"
        style={{
          strokeWidth: 280.382,
        }}

      />
      <path
        d="M8728 16055c-186-436-290-886-325-1333L737 19738c-585 383-770 1158-420 1764 350 607 1113 834 1738 519l8178-4131c-643-443-1175-1064-1505-1835zM14508 17740l73-1307c-588 552-1406 850-2268 746-622-75-1170-350-1593-749l74 1313c420 232 890 391 1395 452 834 101 1636-77 2319-455z"
                className="fill stroke1"
        style={{
          strokeWidth: 280.382,
        }}

      />
      <path
        d="M12138 18615c-470-57-911-191-1317-384l512 9146c39 699 617 1246 1318 1246 700 0 1278-547 1317-1246l513-9148c-706 337-1510 487-2343 386zM16488 14453l-1095-717c184 785 33 1642-489 2337-376 501-887 838-1444 1005l1174 592c410-247 783-574 1089-982 504-672 751-1455 765-2235z"
                className="fill stroke1"
        style={{
          strokeWidth: 280.382,
        }}

      />
      <path
        d="M16061 16942c-285 379-622 694-991 949l8176 4129c625 316 1388 89 1738-518 350-606 166-1380-420-1764l-7666-5017c-61 779-334 1550-837 2221zM14631 11094l-1169 590c772 233 1439 793 1780 1592 246 576 282 1187 148 1753l1100-720c-9-480-106-966-306-1435-330-772-884-1378-1553-1780z"
                className="fill stroke1"
        style={{
          strokeWidth: 280.382,
        }}

      />
      <path
        d="M16573 12708c186 436 290 886 326 1333l7665-5016c586-384 770-1158 420-1764-350-607-1113-834-1738-519l-8178 4131c644 443 1176 1064 1505 1835z"
                className="fill stroke1"
        style={{
          strokeWidth: 280.382,
        }}

      />
    </g>
  </svg>
)
export default SvgComponent
